import { loadModule } from 'holocron';
import { setSubmitted } from '../ducks/formDuck';
import { setIsSearchSubmitting } from '../ducks/searchDuck';
import { getHasErrors } from '../selectors/validationSelectors';
import { getRequestAsJS } from '../selectors/requestSelectors';
import saveCommonCacheThunk from './saveCommonCacheThunk';
import { THC, FHR } from '../constants/smartfillConstants';
import { SEARCH_REDIRECT_MODULE_NAME } from '../constants/globalConstants';

export const onSubmitThunk = (
  taxonomy,
  searchRedirectConfig,
  horizonsConfig
) => async (dispatch, getState) => {
  dispatch(setSubmitted(true));
  if (taxonomy !== THC && taxonomy !== FHR) dispatch(saveCommonCacheThunk());
  const state = getState();

  if (!getHasErrors(state)) {
    dispatch(setIsSearchSubmitting(true));
    const request = getRequestAsJS(state);
    const SearchRedirect = dispatch(loadModule(SEARCH_REDIRECT_MODULE_NAME));

    const {
      searchHotelCollection,
      searchFineHotelsResorts,
      searchHotels,
    } = await SearchRedirect;

    if (taxonomy === THC) {
      dispatch(searchHotelCollection({ ...request, ...searchRedirectConfig, horizonsConfig }));
    } else if (taxonomy === FHR) {
      dispatch(searchFineHotelsResorts({ ...request, ...searchRedirectConfig, horizonsConfig }));
    } else {
      dispatch(
        searchHotels(
          { ...request, ...searchRedirectConfig, horizonsConfig })
      );
    }
  }
};

export default onSubmitThunk;
